
var $body = $('.js-body'),
    //body = document.querySelector('.js-body'),
		//thisPage = $body.attr('data-page'),
		//site = $body.attr('data-site'),
		//height = $(window).height(),
		width = window.innerWidth
;


const header = document.querySelector('.js-header'),
    accordion = document.querySelector(".js-accordion"),
    headerTriggerPoint = 0;

let scrollPos = 0;
